import Logo from "./Logo";

const TopBar = () => {
  return (
    <div className="TopBar">
      <div className="container">
        <div className="TopBar-content">
          <Logo />
        </div>
      </div>
    </div>
  );
};

export default TopBar;
